import { Box, Collapse } from "@material-ui/core";
import styled from "styled-components";

export const CollapseHeader = styled.div`
    padding: 12px 24px;
    display: flex;
    justify-content: space-between;
    border: 1px solid #E2E2E2;
    background-color:  ${(props) => props.open ? '#F9F9F9' :  '#FFFFFF'};
    border-radius: ${(props) => props.open ? '8px 8px 0 0' :  '8px'};
    transition: all .3s ease-out;
`;

export const CollapseHeaderInfo = styled(Box)`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: ${props => props.justifyContent};
    padding-right: 30px;
`

export const CollapseBody = styled(Collapse)`
   border: 1px solid #E2E2E2;
   border-top: none;
   border-radius: 0 0 8px 8px;
`
